const scope = "pivots";
export default scope;
